export interface DateValue {
	date?: Date
	day?: number
	month?: number
	year?: number
}

export enum MonthList {
	JANUARY = 'Январь',
	FEBRUARY = 'Февраль',
	MARCH = 'Март',
	APRIL = 'Апрель',
	MAY = 'Май',
	JUNE = 'Июнь',
	JULY = 'Июль',
	AUGUST = 'Август',
	SEPTEMBER = 'Сентябрь',
	OCTOBER = 'Октябрь',
	NOVEMBER = 'Ноябрь',
	DECEMBER = 'Декабрь'
}
